import * as url from "../url.helper";

import { post } from "../api.helper";

export const addRole = data => post(url.ADD_ROLE, data);

export const getRole = data => post(url.GET_ROLE, data);

export const getRoleByEntityType = data => post(url.GET_ROLE_ENTITYTYPE, data);

export const getOneRole = data => post(url.GET_ONE_ROLE, data);

export const editRole = data => post(url.EDIT_ROLE, data);

export const getRolePermission = data => post(url.GET_ROLEPERMISSION, data)

export const editRolePermission = data => post(url.EDIT_ROLEPERMISSION, data);

export const getUserDashboardWidgetPermission = data => post(url.GET_USER_DASHBOARD_WIDGET_PERMISSION, data);
export const getRolePermissionList = data => post(url.GET_ROLEPERMISSION_LIST, data)

